import React from "react";

const DesignSystemLogo = ({ designSystem }) => {
  const apiUrl = process.env.REACT_APP_SHEET_URL;
  return <img src={`${apiUrl}${designSystem.logo_url}`} />;
};

export default DesignSystemLogo;
